import { render, staticRenderFns } from "./AudienceEdit.vue?vue&type=template&id=0db1dcea&scoped=true&"
import script from "./AudienceEdit.vue?vue&type=script&lang=js&"
export * from "./AudienceEdit.vue?vue&type=script&lang=js&"
import style0 from "./AudienceEdit.vue?vue&type=style&index=0&id=0db1dcea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db1dcea",
  null
  
)

export default component.exports